import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import { Container, media } from 'styled-bootstrap-grid'

const Content = styled.section`
  padding: ${(props) => props.xsPadding || props.padding || '20px 0'};
  ${media.sm`
    padding: ${(props) => (props.padding ? props.padding : '40px 64px')};
  `}
  ${media.md`
    padding: ${(props) => props.mdPadding || props.padding || '20px'};
  `}
  ${media.lg`
    padding: ${(props) => props.lgPadding || props.padding || '40px 64px'};
  `}
  ${(props) => props.textAlign && `text-align: ${props.textAlign};`}
`

const backgroundStyle = css`
  ${(props) => props.backgroundImage && `background-image: url(${props.backgroundImage});`}
  ${(props) => props.attachBg && 'background-attachment: fixed;'}
  background-size: cover;
  background-repeat: no-repeat;
`

const opaqueBackgroundStyle = css`
  position: relative;
  overflow: hidden;

  &:after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    ${(props) => props.opacity && `opacity: ${props.opacity};`}
    ${(props) => props.backgroundImage && `background-image: url(${props.backgroundImage});`}
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }
`

const Background = styled.div`
  ${(props) => (props.opacity ? opaqueBackgroundStyle : backgroundStyle)}
  ${(props) =>
    props.backgroundColor && `background-color: ${props.theme.colors[props.backgroundColor] ?? props.backgroundColor}`}
`

const MaxWidthContainer = styled(Container)`
  ${(props) => props.maxWidth && 'max-width: 1500px'};
  ${(props) => props.customMaxWidth && `max-width:${props.customMaxWidth}px`};
  ${(props) => props.fluid && 'padding: 0px'};
  margin: 0 auto;
`

const Box = styled.div`
  ${(props) =>
    props.visible
      ? css`
          padding: 20px;
          border-radius: 10px;
          box-shadow: ${(props) => props.theme.effects.shadow};
        `
      : null}/* display: flex;
  flex-direction: column;
  align-items: center; */
`

const Section = ({
  backgroundImage,
  backgroundColor,
  maxWidth,
  customMaxWidth,
  fluid,
  padding,
  lgPadding,
  mdPadding,
  xsPadding,
  children,
  opacity,
  textAlign,
  box = false,
  ...props
}) => (
  <Background {...props} opacity={opacity} backgroundImage={backgroundImage} backgroundColor={backgroundColor}>
    <MaxWidthContainer maxWidth={maxWidth} customMaxWidth={customMaxWidth} fluid={maxWidth || fluid}>
      <Content
        box={box}
        textAlign={textAlign}
        xsPadding={xsPadding}
        mdPadding={mdPadding}
        lgPadding={lgPadding}
        padding={padding}
      >
        <Box visible={box}>{children}</Box>
      </Content>
    </MaxWidthContainer>
  </Background>
)

Section.propTypes = {
  backgroundImage: PropTypes.string,
  backgroundColor: PropTypes.string,
  maxWidth: PropTypes.bool,
  customMaxWidth: PropTypes.string,
  fluid: PropTypes.bool,
}

export default Section
